module.exports = __webpack_public_path__ + "static/RoundDining1-b9cc3302e75be8eb48fce8a9a105daaa.jpg";